import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

export const SERVICE_SEARCH_FORM_SUBMIT_TYPES = {
  SEARCH: 'search',
  DOG_BOARDING: 'dogBoarding',
  PET_SITTERS: 'petSitters',
  HOUSE_SITTERS: 'houseSitters',
  DAY_CARE: 'dayCare',
  DOG_WALKERS: 'dogWalkers',
} as const;

export const SERVICE_LANDINGS_WITH_SEARCH_RESULTS: ServiceLandingEnum[] = [
  ServiceLandingEnum.DOG_BOARDING,
  ServiceLandingEnum.HOUSE_SITTING,
  ServiceLandingEnum.PET_SITTING,
  ServiceLandingEnum.DOGGY_DAY_CARE,
  ServiceLandingEnum.DOG_WALKING,
];
